import { GridColDef } from '@mui/x-data-grid-premium';
import { TableColumn } from 'src/components/Table';

export const baseColumns: GridColDef[] = [
  TableColumn?.providerName('name', 'Name'),
  TableColumn?.crm_links('crm_links', 'Status'),
  TableColumn?.email('email', 'Email'),
  TableColumn?.specialty('specialty', 'Specialty'),
  TableColumn?.string('npi', 'NPI'),
  TableColumn?.string('ccn', 'CCN'),
  TableColumn?.string('site_id', 'Site ID'),
  TableColumn?.phone('phone', 'Phone'),
  TableColumn?.address('address', 'Primary Address'),
  TableColumn?.streetAddress('street_address', 'Primary Street Address'),
  TableColumn?.city('city', 'Primary City'),
  TableColumn?.state('state', 'Primary State'),
  TableColumn?.zip('zip_code', 'Primary Zip'),
  TableColumn?.secondaryAddresses(
    'secondary_addresses_v2',
    'Secondary Addresses'
  ),
  TableColumn?.affiliations('affiliations', 'Affiliations'),
  TableColumn?.groups('groups', 'Groups'),
  TableColumn?.systems('systems', 'Hospital Systems'),
];

//For Referring Out and Treating Affiliations tables
export const affiliationsTableColumns: GridColDef[] = [
  ...baseColumns.slice(0, 1),
  TableColumn?.tags('tags', 'Tags'),
  ...baseColumns.slice(1),
];

// For Lists table
const listTableColumnsBase: GridColDef[] = [
  ...baseColumns.slice(0, 1),
  TableColumn?.tags('tags', 'Tags'),
  TableColumn?.dateAdded('created_at', 'Date Added'),
  ...baseColumns.slice(1),
];

//For Referrals table
export const referralTableColumns: GridColDef[] = [
  ...baseColumns.slice(0, 1),
  TableColumn?.totalPatients('total_patients', 'All Shared Patients'),
  TableColumn?.totalClaims('total_claims', 'All Shared Claims'),
  TableColumn?.listMembership('provider_lists', 'Lists'),
  ...baseColumns.slice(1),
];

//For Education table
export const educationTableColumns: GridColDef[] = [
  ...baseColumns.slice(0, 1),
  TableColumn?.institution('institution', 'Institution'),
  TableColumn?.focus('focus', 'Focus'),
  TableColumn?.graduationYear('graduation_year', 'Graduation Year'),
  ...baseColumns.slice(1),
];

//For Relationships table
export const relationshipsTableColumns: GridColDef[] = [
  ...baseColumns.slice(0, 1),
  TableColumn?.tags('tags', 'Tags'),
  ...baseColumns.slice(1),
];

export const strategyListTableColumns: GridColDef[] = [
  TableColumn?.strategyProviderName('name', 'Name'),
  TableColumn?.crm_links('crm_links', 'Status'),
  TableColumn?.tags('tags', 'Tags'),
  TableColumn?.specialty('specialty', 'Specialty'),
  TableColumn?.siteOfCareType('soc_type', 'Site of Care Type'),
  TableColumn?.cityState('city', 'City/State'),
  TableColumn?.affiliations('affiliations', 'Affiliations'),
  TableColumn?.strategyListMembers('list_membership', 'Lists'),
];

export const systemListTableColumns: GridColDef[] = [
  TableColumn?.systemName('name', 'Name'),
  TableColumn?.siteOfCareType('soc_type', 'Site of Care Type'),
  ...baseColumns.slice(1, 3), // crm_links, email
  ...baseColumns.slice(4), // everything after specialty
  TableColumn?.isTeaching('is_teaching_hospital', 'Is Teaching?'),
  TableColumn?.staffedBeds('total_bed_count', 'Staffed Beds'),
  TableColumn?.operatingRooms('operating_room_count', 'Operating Rooms'),
  TableColumn?.emr('ehrs', 'EHR Provider'),
  TableColumn?.gpo('gpos', 'GPO'),
  TableColumn?.patientRevenue('total_patient_revenue', 'Patient Revenue', true),
  TableColumn?.currentAssets('total_current_assets', 'Current Assets', true),
  TableColumn?.totalAssets('total_assets', 'Total Assets', true),
  TableColumn?.currentLiability(
    'total_current_liabilities',
    'Current Liability',
    true
  ),
];

// Lists table columns with the Site of Care Type column inserted right after
// Specialty (appended if Specialty isn't present).
const listSpecialtyIndex = listTableColumnsBase.findIndex(
  (column) => column.field === 'specialty'
);

const socInsertIndex =
  listSpecialtyIndex === -1
    ? listTableColumnsBase.length
    : listSpecialtyIndex + 1;

export const listTableColumns: GridColDef[] = [
  ...listTableColumnsBase.slice(0, socInsertIndex),
  TableColumn?.siteOfCareType('soc_type', 'Site of Care Type'),
  ...listTableColumnsBase.slice(socInsertIndex),
];
